export default __webpack_public_path__ + "static/media/maduro-5Open.7d4fb997.jpg";